export const COL_FROZEN_PERIOD = "frozenPeriod";
export const COL_QTY_MIN = "quantityMin";
export const COL_COVERAGE_MIN = "coverageMin";
export const COL_COVERAGE_MAX = "coverageMax";
export const COL_ORDER_MULTIPLE = "orderMultiple";

export const IS_DATA_LINE = "isDataLine";
export const MAX_MONTH_QTY = 24;
